import Icon from '@/components/snippets/icon/icon'
import { useSort } from 'libs/searchspring/hooks/useSort'

export function FilterSort({ id = 'sort' }) {
  const { sorts, activeSort, handleSort, resetSort } = useSort()

  return (
    <x-modal className="group data-visible:z-1" data-id={id}>
      <button
        className="flex items-center gap-x-0.375 link-fade"
        data-modal-parent={id}
        data-modal-role="toggle"
        aria-label="Toggle Sort By"
      >
        <div class="w-[16px] h-[15px] children:size-full">
          <Icon id="sort" />
        </div>
        <span className="text-s font-medium font-line">
          Sort by{activeSort ? <span className="hidden lg:inline">: {sorts.find(sort => sort.value === activeSort)?.label}</span> : ''}
        </span>
      </button>
      <div
        className="flex flex-col gap-y-2 fixed lg:absolute bottom-0 lg:top-full right-0 lg:right-1.25 w-full lg:w-fit h-fit px-margin lg:px-1.5 pt-1 pb-1.875 lg:pb-2.5 bg-secondary lg:shadow-sort lg:opacity-0 lg:group-data-visible:opacity-100 translate-y-full lg-max:group-data-visible:translate-y-0 lg:translate-y-px pointer-events-none group-data-visible:pointer-events-auto z-70 lg:z-40 transition-all"
      >
        <div className="flex gap-x-1 items-center justify-between w-full">
          <h2 className="paragraph-b font-medium whitespace-nowrap">Sort By</h2>
          <button
            className="shrink-0 size-[13px] children:size-full link-fade"
            data-modal-parent={id}
            data-modal-role="close"
            aria-label="Close Sort By"
          >
            <Icon id="close" />
          </button>
        </div>
        <div className="flex flex-col gap-y-1.875">
          <div className="flex items-center gap-x-0.5 w-fit cursor-pointer">
            <input
              id={'sort__default'}
              className="field-radio"
              type="radio"
              value='default'
              name="sort"
              onClick={() => resetSort()}
              checked={!activeSort}
              aria-label="Recommended"
            />
            <label for={'sort__default'} className="text-s whitespace-nowrap cursor-pointer">
              Recommended
            </label>
          </div>
          {sorts?.map((sort) => (
            <div className="flex items-center gap-x-0.5 w-fit cursor-pointer">
              <input
                id={`sort__${sort.value}`}
                className="field-radio"
                type="radio"
                value={sort.value}
                name="sort"
                onClick={() => handleSort(sort.value)}
                checked={activeSort === sort.value}
                aria-label={sort.label}
              />
              <label for={`sort__${sort.value}`} className="text-s whitespace-nowrap cursor-pointer">
                {sort.label}
              </label>
            </div>
          ))}
        </div>
      </div>
      <button
        class="lg:hidden fixed inset-tl size-full bg-neutral-black/60 opacity-0 group-data-visible:opacity-100 pointer-events-none group-data-visible:pointer-events-auto cursor-s-resize z-60 transition-all"
        data-modal-parent={id}
        data-modal-role="close"
        aria-label="Close Sort By"
      >
      </button>
    </x-modal>
  )
}
